import React from 'react';
import PropTypes from 'prop-types';
import NewChatSearch from "../../../components/messaging/new-chat-search";
import FollowingSortByComponent from "../../../components/Following/sort-by";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "react-loading-animation";
import FollowingItem from "../../../components/Following/item";
import "./index.css";

FollowingContainer.propTypes = {
    followingList: PropTypes.array.isRequired,
    searchInFollowingList: PropTypes.func.isRequired,
    sortBy: PropTypes.string.isRequired,
    setSortBy: PropTypes.func.isRequired,
    loadNextPage: PropTypes.func.isRequired,
    hasMore: PropTypes.bool.isRequired,
    searchText: PropTypes.string.isRequired,
};

function FollowingContainer(props) {
    return (
        <div className="all-followers-container">
            <div className="display-flex-align-center-justify-content-space-between">
                <span className="all-followers-count">All Followers ({props.followingList.length})</span>
                <div className="display-flex-align-center">
                    <NewChatSearch
                        searchText={props.searchText}
                        placeholder={"Search on username"}
                        className="all-followers-search-input"
                        search={props.searchInFollowingList}/>
                    <FollowingSortByComponent sortBy={props.sortBy} setSortBy={props.setSortBy}/>
                </div>
            </div>

            {/* My Following list */}
            <InfiniteScroll
                height={window.innerHeight - 480}
                className="all-followers-scroll-component"
                dataLength={props.followingList.length}
                next={props.loadNextPage}
                hasMore={props.hasMore}
                loader={<Loading/>}
                endMessage={<span/>}>
                {
                    props.followingList.map((following, index) => {
                        return (
                            <FollowingItem
                                key={following.id}
                                index={index}
                                broadcaster_id={following.broadcaster_id}
                                profile_pic={following.profile_pic}
                                username={following.username}
                                is_verified={following.is_verified}
                                followers_count={following.followers_count}
                                is_following={following.is_following}

                                currentUserData={props.currentUserData}

                                following={props.following}
                                clickedOnChat={props.clickedOnChat}
                                clickedOnFollowUnfollow={props.clickedOnFollowUnfollow}
                            />
                        )
                    })
                }
            </InfiniteScroll>
            {/* My Following list */}
        </div>
    );
}

export default FollowingContainer;